import { createAction, handleActions } from 'redux-actions';

const setProcurementItemForEdit = createAction("SCREENS/ORDER_VIEW/SET_PROCUREMENT_ITEM_FOR_EDIT");
const clearProcurementItemForEdit = createAction("SCREENS/ORDER_VIEW/CLEAR_PROCUREMENT_ITEM_FOR_EDIT");

const defaultState = null;

const reducer = handleActions(
  {
    [setProcurementItemForEdit]: (state, action) => action.payload,
    [clearProcurementItemForEdit]: () => null,
    'SCREENS/ORDER_VIEW/HIDE_PROCUREMENT_ITEM_MODAL': () => null,
    'RESET_ORDER_VIEW': () => defaultState,
  },
  defaultState
);

export { setProcurementItemForEdit, clearProcurementItemForEdit, reducer };
